"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkUpdateAssetsRequestToJSON = exports.BulkUpdateAssetsRequestFromJSONTyped = exports.BulkUpdateAssetsRequestFromJSON = exports.instanceOfBulkUpdateAssetsRequest = exports.BulkUpdateAssetsRequestActionEnum = void 0;
/**
 * @export
 */
exports.BulkUpdateAssetsRequestActionEnum = {
    Archive: 'ARCHIVE',
    Unarchive: 'UNARCHIVE'
};
/**
 * Check if a given object implements the BulkUpdateAssetsRequest interface.
 */
function instanceOfBulkUpdateAssetsRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "ids" in value;
    return isInstance;
}
exports.instanceOfBulkUpdateAssetsRequest = instanceOfBulkUpdateAssetsRequest;
function BulkUpdateAssetsRequestFromJSON(json) {
    return BulkUpdateAssetsRequestFromJSONTyped(json, false);
}
exports.BulkUpdateAssetsRequestFromJSON = BulkUpdateAssetsRequestFromJSON;
function BulkUpdateAssetsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'action': json['action'],
        'ids': json['ids'],
    };
}
exports.BulkUpdateAssetsRequestFromJSONTyped = BulkUpdateAssetsRequestFromJSONTyped;
function BulkUpdateAssetsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'action': value.action,
        'ids': Array.from(value.ids),
    };
}
exports.BulkUpdateAssetsRequestToJSON = BulkUpdateAssetsRequestToJSON;
